import { styled } from '@linaria/react';
import { layout, primitives, semantic, size, space } from '../../theme/tokens';

export const Track = styled.div`
  display: flex;
  width: 100%;
  height: 100%;
  aspect-ratio: 400 / 460;
  max-height: 60vh;
  transform: translateX(calc(var(--gallery-index, 0) * -100%));
  transition: transform 0.35s ease;

  @media (min-width: ${layout.desktopBreakpoint}) {
    aspect-ratio: auto;
    max-height: none;
  }

  @media (prefers-reduced-motion: reduce) {
    transition: none;
  }
`;

export const Slide = styled.div`
  flex: 0 0 100%;
  width: 100%;
  height: 100%;
`;

export const Controls = styled.div`
  position: absolute;
  bottom: ${space['space-600']};
  left: ${space['space-600']};
  right: ${space['space-600']};
  display: flex;
  align-items: center;
  justify-content: space-between;
  z-index: 2;
`;

export const NavGroup = styled.div`
  display: flex;
  align-items: center;
  padding: ${space['space-100']};
  background: ${semantic.bg.overlayBlur};
  backdrop-filter: blur(${size.blur['blur-lg']});
  border-radius: ${size.radius['radius-full']};
`;

export const Dots = styled.div`
  display: flex;
  align-items: center;
  gap: ${space['space-200']};
`;

export const Dot = styled.button`
  width: ${primitives.size['size-100']};
  height: ${primitives.size['size-100']};
  padding: 0;
  border: none;
  border-radius: ${size.radius['radius-full']};
  background: ${semantic.bg.secondary};
  opacity: 0.5;
  cursor: pointer;
  transition: width 0.2s ease;

  &[data-active='true'] {
    width: ${primitives.size['size-400']};
    opacity: 1;
  }
`;
